<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    id: { type: String, required: true },
    title: { type: String, default: '' },
    titleT: { type: String, default: '' },
    centered: { type: Boolean, default: true },
    scrollable: { type: Boolean, default: true },
    showHeader: { type: Boolean, default: true },
    closeButtonInTitle: { type: Boolean, default: true },
    closeButtonInContent: { type: Boolean, default: false },
    closeWithBackdrop: { type: Boolean, default: true },
    classModalDialog: { type: String, default: '' },
    classContent: { type: String, default: '' },
    classHeader: { type: String, default: '' },
    classBody: { type: String, default: '' },
    classFooter: { type: String, default: '' },
    idModalPage: { type: String, default: '' },
    e2eModal: { type: String, default: '' },
    multiple: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    fullscreen: { type: Boolean, default: false },
  },
  emits: ['icon-close'],
  data() {
    return {
      isClosing: false,
    }
  },

  computed: {
    classForModalDialog: function () {
      const classes = [this.classModalDialog, 'modal-dialog']
      if (this.centered) {
        classes.push('modal-dialog-centered')
      }

      if (this.scrollable) {
        classes.push('modal-dialog-scrollable')
      }

      if (this.fullscreen) {
        classes.push('modal-fullscreen')
      } else if (this.large) {
        classes.push('modal-xl')
      }

      return classes
    },

    titleComputed: function () {
      if (this.titleT) {
        return this.$root.$t(this.titleT)
      }
      return this.title
    },
  },

  methods: {
    open() {
      this.isClosing = false
      const escapedId = this.id.replace(/\./g, '\\.')
      jQuery(`#${escapedId}`).modal('show')
    },
    close(withEmit = true) {
      this.resetErrors()
      const escapedId = this.id.replace(/\./g, '\\.')
      jQuery(`#${escapedId}`).modal('hide')
      if (withEmit) {
        this.$emit('icon-close')
      }
    },
    resetErrors() {
      const modalEl = document.getElementById(this.id)
      if (!modalEl) {
        return
      }
      const invalidInputs = modalEl.querySelectorAll('.form-control')
      invalidInputs.forEach((input) => {
        input.classList.remove('is-invalid')
      })

      const invalidFeedbacks = modalEl.querySelectorAll('.invalid')
      invalidFeedbacks.forEach((feedback) => {
        feedback.textContent = ''
      })
    },
  },

  mounted() {
    const escapedId = this.id.replace(/\./g, '\\.')
    jQuery(`#${escapedId}`).on('hidden.bs.modal', (e) => {
      if (e.target.id !== this.id) {
        return
      }

      if (!this.isClosing) {
        this.$emit('icon-close')
      }

      setTimeout(() => {
        this.isClosing = false
      }, 100)
    })
  },

  beforeUnmount() {
    const escapedId = this.id.replace(/\./g, '\\.')
    jQuery(`#${escapedId}`).off('hidden.bs.modal')
    this.close(false)
  },
}
</script>
<template>
  <Teleport to="body">
    <div
      class="modal modal-background-dark fade form-type-round"
      :id="id"
      :e2e-modal="e2eModal || null"
      tabindex="-1"
      :aria-labelledby="id"
      aria-hidden="true"
      :data-backdrop="closeWithBackdrop ? true : 'static'"
      v-bind="$attrs"
    >
      <div :class="classForModalDialog" role="document">
        <div :class="'modal-content ' + classContent">
          <div :class="'modal-header ' + classHeader" v-if="showHeader">
            <h5 v-if="titleComputed" class="modal-title" :id="id + 'Title'">{{ titleComputed }}</h5>
            <slot name="header"></slot>
            <button
              v-if="closeButtonInTitle"
              type="button"
              class="close modal-close-btn"
              :aria-label="$t('main.dismiss')"
              @click="close"
              e2e-button="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <button
            v-if="!closeButtonInTitle && closeButtonInContent"
            type="button"
            class="close modal-close-btn"
            :aria-label="$t('main.dismiss')"
            @click="close"
            e2e-button="closeModalFromContent"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div :class="'modal-body ' + classBody" v-if="$slots.default || $slots.body">
            <slot></slot>
            <slot name="body"></slot>
          </div>
          <div :class="'modal-footer ' + classFooter" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
